import React, { useState } from "react";
import { Container, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { api } from "../api"; // <-- adjust if your api.ts is elsewhere

interface AdminLoginProps {
  setToken: (token: string) => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ setToken }) => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const [error, setError] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      // Keep your current backend login route for compatibility.
      // Later, when you update Django, we’ll change this to something like POST /auth/login/
      const res = await api.post(
        "/54a239ebdfed69e151b3cd0ab198103812be45f837f6a5409401227073aef95f/871869008b2558e5f73046c390fcecd0c834849e8d9c8575af48e98c4cd1be2f/",
        { username, password }
      );

      // Transitional mode:
      // - Today your backend returns { access, refresh }
      // - We keep access token ONLY in memory via setToken (no localStorage)
      const { access } = res.data || {};
      if (!access) {
        setError("Login failed (missing access token).");
        return;
      }

      setToken(access);
      navigate("/admin");
    } catch (err: any) {
      // Optional: show nicer errors if backend sends detail message
      const msg =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Invalid credentials or unauthorized access.";
      setError(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="my-5" style={{ maxWidth: 520 }}>
      <h1 className="mb-3">Admin Login</h1>

      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formUsername" className="mb-3">
          <Form.Label>Username</Form.Label>
          <Form.Control
            type="text"
            value={username}
            autoComplete="username"
            onChange={(e) => {
              setUsername(e.target.value);
              if (error) setError("");
            }}
            required
          />
        </Form.Group>

        <Form.Group controlId="formPassword" className="mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            value={password}
            autoComplete="current-password"
            onChange={(e) => {
              setPassword(e.target.value);
              if (error) setError("");
            }}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Logging in…
            </>
          ) : (
            "Login"
          )}
        </Button>
      </Form>
    </Container>
  );
};

export default AdminLogin;
